$(function () {
  var clones = [];

  function toggleConditional(el, id, show) {
    if (show) {
      $(el).insertAfter($('[data-fieldset="' + id + '"]'));
      $(el).show();
      $(el).attr('aria-hidden', false);
    } else {
      $(el).hide();
      $(el).attr('aria-hidden', true);
      $('#' + $(el).attr('id') + '.togglable').remove();
    }
  }

  function applyMasks() {
    $('input.phone').mask('(999) 999-9999', { autoclear: false });
    $('input.phone-required').mask('(999) 999-9999', { autoclear: false });
    $('input.currency').maskMoney({ prefix: '$', allowZero: true });
    $('input.currency-required').maskMoney({ prefix: '$', allowZero: true });
    $('input.date').mask('99/99/9999', { autoclear: false });
    $('input.date-required').mask('99/99/9999', { autoclear: false });
  }

  $('.togglable').each(function () {
    clones.push($(this).clone());
  });

  $('.toggle-box, .radio-toggle').each(function () {
    if (!$(this).prop('checked')) {
      var toRemove = '.togglable#' + $(this).val();

      $(toRemove).remove();
    }
  });

  $('.toggle-box').on('click', function (e) {
    var fieldSetId = this.value,
      checked = this.checked;

    clones.forEach(function (el, i, arr) {
      if ($(el).attr('id') === fieldSetId) {
        toggleConditional(el, fieldSetId, checked);
      }
    });

    applyMasks();
  });

  $('.radio-toggle').on('click', function () {
    var fieldSetId = this.value,
      show = this.id.split('_')[0] === 'yes'; // 'yes' or 'no'

    clones.forEach(function (el, i, arr) {
      if ($(el).attr('id') === fieldSetId) {
        toggleConditional(el, fieldSetId, show);
      }
    });

    applyMasks();
  });
});
